// Ultra persistent thumbnails - constant checking
function addThumbnails() {
  const labels = document.querySelectorAll('.product-form__input label');
  const images = document.querySelectorAll('.product__media-item img');
  
  labels.forEach(function(label, i) {
    if (images[i] && !label.querySelector('.variant-thumb')) {
      const thumb = document.createElement('span');
      thumb.className = 'variant-thumb';
      thumb.style.cssText = 'display:inline-block!important;width:30px!important;height:30px!important;margin-right:8px!important;background-image:url(' + images[i].src + ')!important;background-size:cover!important;background-position:center!important;border-radius:4px!important;flex-shrink:0!important;';
      
      label.style.cssText = 'display:inline-flex!important;align-items:center!important;';
      label.insertBefore(thumb, label.firstChild);
    }
  });
}

// Run on load
window.addEventListener('load', addThumbnails);

// Run constantly every 1ms
setInterval(addThumbnails, 1);
